'use strict';

exports.__esModule = true;
exports.default = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _subscription = require('../../../query/subscription');

var _context4 = require('@prisma-cms/context');

var _context5 = _interopRequireDefault(_context4);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var CallRequestsSubscriber = (_temp = _class = function (_Component) {
  _inherits(CallRequestsSubscriber, _Component);

  function CallRequestsSubscriber() {
    _classCallCheck(this, CallRequestsSubscriber);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  } // static contextTypes = {
  //   client: PropTypes.object.isRequired,
  //   localStorage: PropTypes.object.isRequired,
  // };


  CallRequestsSubscriber.prototype.componentDidMount = function componentDidMount() {
    this.subscribe();
  };

  CallRequestsSubscriber.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unsubscribe();
  }; // componentDidUpdate(){
  //   super.componentDidUpdate && super.componentDidUpdate();
  // }


  CallRequestsSubscriber.prototype.subscribe = function subscribe() {
    var _this2 = this; // call the "subscribe" method on Apollo Client


    if (this.subscriptionObserver) {
      return;
    }

    var client = this.context.client; // const {
    //   user: currentUser,
    // } = this.props;
    // if (!currentUser) {
    //   return;
    // }
    // const {
    //   id: subscriberId,
    // } = currentUser;
    // const {
    //   token,
    // } = localStorage;

    this.subscriptionObserver = client.subscribe({
      query: _subscription.callRequestSubscription,
      variables: {// subscriberId,
        // token,
      }
    }).subscribe({
      next: function () {
        var _ref = _asyncToGenerator(
        /*#__PURE__*/
        _regenerator2.default.mark(function _callee(response) {
          var errors, data, onDataReceived, result;
          return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  // ... call updateQuery to integrate the new comment
                  // into the existing list of comments
                  errors = response.errors, data = response.data;

                  if (!(errors && errors.length || !data)) {
                    _context.next = 5;
                    break;
                  }

                  _this2.setState({
                    error: errors[0].message
                  });

                  _context.next = 10;
                  break;

                case 5:
                  onDataReceived = _this2.props.onDataReceived;
                  result = onDataReceived && onDataReceived(data);
                  _context.next = 9;
                  return _this2.reloadData();

                case 9:
                  return _context.abrupt('return', result);

                case 10:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this2);
        }));

        return function next(_x) {
          return _ref.apply(this, arguments);
        };
      }(),
      error: function error(err) {
        console.error('callRequestSubscription subscribe err', err);

        _this2.setState({
          subscribeError: err.message
        });
      }
    });
  };

  CallRequestsSubscriber.prototype.unsubscribe = function unsubscribe() {
    if (this.subscriptionObserver) {
      this.subscriptionObserver.unsubscribe();
    }
  };

  CallRequestsSubscriber.prototype.reloadData = function () {
    var _ref2 = _asyncToGenerator(
    /*#__PURE__*/
    _regenerator2.default.mark(function _callee2() {
      var _context2, client, loadApiData, rendererForceUpdate;

      return _regenerator2.default.wrap(function _callee2$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context2 = this.context, client = _context2.client, loadApiData = _context2.loadApiData, rendererForceUpdate = _context2.rendererForceUpdate;
              _context3.next = 3;
              return loadApiData();

            case 3:
              _context3.next = 5;
              return client.resetStore();

            case 5:
              rendererForceUpdate();

            case 6:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee2, this);
    }));

    function reloadData() {
      return _ref2.apply(this, arguments);
    }

    return reloadData;
  }();

  CallRequestsSubscriber.prototype.render = function render() {
    return null;
  };

  return CallRequestsSubscriber;
}(_react.Component), _class.contextType = _context5.default, _temp);
exports.default = CallRequestsSubscriber;
CallRequestsSubscriber.propTypes = process.env.NODE_ENV !== "production" ? {
  user: _propTypes2.default.object.isRequired,
  onDataReceived: _propTypes2.default.func.isRequired
} : {};
module.exports = exports['default'];